<template>
  <div>
    <div class="right-title">
      <span>顾问权限</span>
      <el-button plain class="go-back" @click="goBack">返回</el-button>
    </div>
    <div class="content-box">
      <div class="title">区域划分</div>
      <div style="padding: 20px 30px;">
        <div v-show="isshowQg">
          <el-checkbox v-model="quanguo" @change="quanguoChang">全国</el-checkbox>
          <div style="margin: 15px 0;"></div>
        </div>
        <div v-show="!quanguo" v-for="(item,index) in cityAllList" :key="item.id">
          <el-checkbox :indeterminate="item.isIndeterminate" v-model="item.state" @change="handleCheckAllChange(index)">
            {{item.categoryname}}
          </el-checkbox>

          <div style="padding-left: 30px;">
            <el-checkbox v-for="(city,j) in item.er" v-model="city.state" @change="handleCheckedCitiesChange(index,j)"
                         :label="city.categoryname" :key="city.id">{{city.categoryname}}
            </el-checkbox>
          </div>
          <div style="margin: 15px 0;"></div>
        </div>
        <div class="btn-box">
          <el-button type="primary" @click="tiJiao()" class="submit-btn">保存</el-button>
        </div>
      </div>

    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    name: "gwQuanxian",
    data() {
      return {
        id: '',                    //顾问id
        cityAllList: [],               // 全部城市
        chioseCityArr: [],         //  选择的城市
        quanguo: false,             //  是否选择全国
        isshowQg: false            //  是否显示全国
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.$emit('setType', 0)
      //顾问id
      let _id = this.$route.params.id
      this.id = _id
      //权限信息
      this.detal()
    },
    methods: {
      handleChecked(value) {
        this.checkedCities = value
      },
      //权限详情
      detal() {
        this.$api.apiContent.gwQuanx({
          user_id: this.id,
          admin_id: this.user.id
        }).then(res => {

          if (res.data.type === 2) {
            this.isshowQg = true
            if (res.data.typeid === 1) {
              this.quanguo = true
            }
          }
          res.data.kexuan.map(item => {
            item.state = false
            item.isIndeterminate = false
            item.checkedCities = []
            item.er.map(items => {
              items.state = false
            })
          })
          this.cityAllList = res.data.kexuan
          this.chioseCityArr = res.data.yixuan
          this.cityAllList.map(item => {
            item.er.map(items => {
              this.chioseCityArr.map(itemss => {
                if (itemss.city_id === items.id) {
                  items.state = true
                }
              })
            })
          })
          this.cityAllList.map(item => {
            item.er.map(items => {
              if (items.state) {
                item.checkedCities.push(items)
              }
            })
            if (item.checkedCities.length === item.er.length && item.checkedCities.length !==0) {
              item.state = true
            }
          })
          console.log(this.chioseCityArr)
        }).catch(res => {
          this.$message.error(res.info);
        })
      },
      goBack() {
        this.$tools.goBack()
      },
      //  点击全国
      quanguoChang() {
        if (!this.quanguo) {
          this.cityAllList.map(item => {
            item.state = false
            item.checkedCities = []
            item.er.map(items => {
              items.state = false
            })
          })
          this.chioseCityArr=[]
        }
      },
      //  选择全省
      handleCheckAllChange(index) {
        let _state = this.cityAllList[index].state
        this.cityAllList[index].er.map(item => {
          console.log(item)
          item.state = _state
        })
      },
      //  选择市
      handleCheckedCitiesChange(index, j) {
        let _id = this.cityAllList[index].er[j].id
        if (this.cityAllList[index].checkedCities.indexOf(_id) === -1) {
          this.cityAllList[index].checkedCities.push(_id)
        } else {
          this.cityAllList[index].checkedCities.splice(this.cityAllList[index].checkedCities.findIndex(item => item === _id), 1)
        }
        if (this.cityAllList[index].checkedCities.length === this.cityAllList[index].er.length) {
          this.cityAllList[index].state = true
        } else {
          this.cityAllList[index].state = false
        }
      },
      //修改权限
      tiJiao() {
        this.chioseCityArr=[]
        const loading = this.$loading({
          look: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0,0,0,0.7)'
        });
        let _obj =''
        let _arr =[]
        if(this.isshowQg){
          if(this.quanguo){
            _obj ={
              user_id: this.id,
              admin_id: this.user.id,
              cityId: '',
              typeid:1,

            }
          }else{
            this.cityAllList.map(item=>{
              item.er.map(items=>{
                if(items.state){
                  this.chioseCityArr.push(items)
                }
              })
            })

            this.chioseCityArr.map(item=>{
              if(item.id){
                _arr.push(item.id)
              }
            })

            _obj ={
              user_id: this.id,
              admin_id: this.user.id,
              cityId: _arr.join(','),
              typeid:3,

            }
          }
        }else{
          this.cityAllList.map(item=>{
            item.er.map(items=>{
              if(items.state){
                this.chioseCityArr.push(items)
              }
            })
          })
          this.chioseCityArr.map(item=>{
            if(item.id){
              _arr.push(item.id)
            }

          })
          _obj ={
            user_id: this.id,
            admin_id: this.user.id,
            cityId: _arr.join(','),
            typeid:3,

          }
        }
        this.$api.apiContent.gwQuanxEdit(_obj)
          .then(res => {
            loading.close();
            this.$message.success(res.info);
            this.$router.go(-1);
          }).catch(res => {
          loading.close();
          this.$message.error(res.info);
        })
      },
    },

    watch: {},
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .content-box {
    .title {
      height: 40px;
      line-height: 40px;
      padding: 0 10px;
      font-size: 16px;
      background-color: #eff1f6;
    }

    .city-box {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      border-left: 1px solid #eff1f6;
      border-right: 1px solid #eff1f6;
      border-bottom: 1px solid #eff1f6;
      justify-content: flex-start;

      .items {
        width: 16.66%;
        height: 40px;
        text-align: left;
        padding: 10px;
        /*border-bottom: 1px solid #eff1f6;*/
      }
    }

    .btn-box {
      padding: 20px 0;

      .submit-btn {
        display: block;
        width: 200px;
        margin: 0 auto;
      }
    }
  }
</style>